import { render, staticRenderFns } from "./resaveQueriesButton.vue?vue&type=template&id=797cddaa"
import script from "./resaveQueriesButton.vue?vue&type=script&lang=js"
export * from "./resaveQueriesButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports